"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter.vue"));
var _editwith = _interopRequireDefault(require("@/views/run/_editwith.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'agentAlarm',
  components: {
    editwith: _editwith.default,
    drawer: _filter.default,
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      nowTime: Date.parse(new Date()) / 1000,
      form: {},
      tableMaxH: '250',
      list: [],
      listLoading: true,
      listQuery: {
        page_num: 1,
        limit: 20,
        type: 1
      }
    };
  },
  computed: {},
  mounted: function mounted() {
    this.$refs.filterDrawer.hide();
    this.getList();
  },
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getList();
    },
    /**
     * 获取列表数据
     */
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.listQuery, this.form, {
        start: this.listQuery.start - 1
      });
      this.$get('agentapi/business/agent_businessing_worns', listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
        if (listQuery.start == 0) _this.tableMaxH = window.innerHeight - _this.$refs.equip_table.$el.offsetTop - 85;
      }).catch(function () {
        _this.listLoading = false;
      });
    }
  }
};